var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPresion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 65.29 101",
    style: {
      enableBackground: "new 0 0 65.29 101"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000134951949587596806760000006717364799450777481_);}\r\n\t.st2{fill:url(#SVGID_00000018214633491437760420000009459148333152291762_);}\r\n\t.st3{fill:url(#SVGID_00000133503925729339466580000006087839442234103224_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.2501,
    y1: 13.0262,
    x2: 56.0035,
    y2: 70.9018
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9677,
    style: {
      stopColor: "#6773E9"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.74,47.09c-0.99-0.99-0.99-2.52,0-3.51c0.94-0.94,2.52-0.94,3.46,0l5.92,5.93V3.47 c0-1.38,1.14-2.47,2.47-2.47c1.38,0,2.47,1.09,2.47,2.47v46.04l5.93-5.93c0.94-0.94,2.52-0.94,3.51,0c0.94,0.99,0.94,2.52,0,3.51 l-9.98,9.92l-0.02,0.03c-0.45,0.56-1.13,0.92-1.91,0.92c-0.24,0-0.48-0.04-0.7-0.11c-0.24-0.07-0.45-0.18-0.65-0.32 c-0.07-0.04-0.13-0.09-0.2-0.15c-0.07-0.05-0.13-0.11-0.18-0.17h-0.05L1.74,47.09z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112630488079152313750000002663359000247548067_",
    gradientUnits: "userSpaceOnUse",
    x1: -7.3075,
    y1: 17.1802,
    x2: 51.9589,
    y2: 75.0683
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9677,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112630488079152313750000002663359000247548067_)"
    },
    d: "M24.26,70.3l5.93,5.93V30.19 c0-1.33,1.09-2.47,2.47-2.47c1.33,0,2.47,1.14,2.47,2.47v46.03l5.88-5.92c0.99-0.93,2.57-0.93,3.5,0c0.99,0.99,0.99,2.57,0,3.51 l-9.92,9.93l-0.2,0.2c-0.06,0.06-0.11,0.13-0.18,0.18c-0.07,0.04-0.14,0.1-0.21,0.15c-0.14,0.09-0.29,0.17-0.44,0.23 c-0.07,0.03-0.15,0.05-0.22,0.08c-0.16,0.04-0.31,0.07-0.47,0.09c-0.25,0.03-0.51,0.01-0.76-0.05c-0.07-0.01-0.13-0.03-0.19-0.05 c-0.36-0.11-0.71-0.31-1.01-0.61c-0.01,0-0.02-0.01-0.03-0.02L20.75,73.81c-0.93-0.94-0.93-2.52,0-3.51 C21.74,69.37,23.27,69.37,24.26,70.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028300611945130870720000010065302003857151365_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.3544,
    y1: -6.0213,
    x2: 74.608,
    y2: 51.8543
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9677,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028300611945130870720000010065302003857151365_)"
    },
    d: "M39.82,47.09c-0.99-0.99-0.99-2.52,0-3.51 c0.94-0.94,2.52-0.94,3.46,0l5.93,5.93V3.47c0-1.38,1.13-2.47,2.47-2.47c1.38,0,2.47,1.09,2.47,2.47v46.04l5.93-5.93 c0.98-0.94,2.51-0.94,3.5,0c0.94,0.99,0.94,2.52,0,3.51L53.46,57.21c-0.06,0.06-0.13,0.12-0.19,0.17c-0.13,0.11-0.27,0.21-0.42,0.28 c-0.15,0.08-0.3,0.14-0.45,0.19c-0.19,0.06-0.38,0.09-0.58,0.1c0,0-0.01,0-0.01,0c-0.04,0-0.08,0.01-0.12,0.01 c-0.35,0-0.69-0.09-1-0.23c-0.02-0.01-0.05-0.02-0.07-0.03c-0.17-0.09-0.34-0.19-0.48-0.32c0,0,0,0-0.01,0 c-0.12-0.1-0.24-0.21-0.34-0.34L39.82,47.09z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137125515916645996340000016694207519788746369_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.9968,
    y1: 78.0298,
    x2: 63.7584,
    y2: 137.7902
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137125515916645996340000016694207519788746369_)"
    },
    d: "M64.29,91.51v7.59c0,1.05-0.85,1.9-1.9,1.9 H2.89C1.85,101,1,100.15,1,99.1v-7.59c0-1.05,0.85-1.9,1.89-1.9h59.5C63.44,89.61,64.29,90.46,64.29,91.51z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresion);
export default __webpack_public_path__ + "static/media/presion.a1edce8c33cf8fa09100e1e329afe5fe.svg";
export { ForwardRef as ReactComponent };